import React, { PropTypes } from 'react';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const styles = {
  radioButtonGroup: {
    display: 'inline-flex',
  },
  radioButton: {
    width: 100,
  },
};

const brandCodes = [
  {
    value: 'A',
    text: 'A',
  },
  {
    value: 'B',
    text: 'B',
  },
  {
    value: 'C',
    text: 'C',
  },
  {
    value: 'D',
    text: 'D',
  },
  {
    value: 'E',
    text: 'E',
  },
  {
    value: 'F',
    text: 'F',
  },
  {
    value: 'G',
    text: 'G',
  },
  {
    value: 'H',
    text: 'H',
  },
  {
    value: 'I',
    text: 'I',
  },
  {
    value: 'J',
    text: 'J',
  },
  {
    value: 'K',
    text: 'K',
  },
  {
    value: 'L',
    text: 'L',
  },
  {
    value: 'M',
    text: 'M',
  },
  {
    value: 'N',
    text: 'N',
  },
  {
    value: 'O',
    text: 'O',
  },
  {
    value: 'P',
    text: 'P',
  },
  {
    value: 'Q',
    text: 'Q',
  },
  {
    value: 'R',
    text: 'R',
  },
  {
    value: 'S',
    text: 'S',
  },
  {
    value: 'T',
    text: 'T',
  },
  {
    value: 'U',
    text: 'U',
  },
  {
    value: 'V',
    text: 'V',
  },
  {
    value: 'W',
    text: 'W',
  },
  {
    value: 'X',
    text: 'X',
  },
  {
    value: 'Y',
    text: 'Y',
  },
  {
    value: 'Z',
    text: 'Z',
  },
];

const BrandListRow = ({ brand, rowStyles, onChange, onDelete }) => {
  const wrapOnChange = (fnc, field, event, value) => {
    fnc(field, value);
  };

  const wrapSelecFieldtOnChange = (fnc, field, event, index, value) => {
    fnc(field, value);
  };

  return (
    <TableRow>
      <TableRowColumn style={rowStyles.column.name}>
        <TextField
          hintText="中文名稱"
          name="name.zhTW"
          value={brand.name.zhTW}
          onChange={wrapOnChange.bind(this, onChange, 'name.zhTW')}
          type="text"
        />
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.name}>
        <TextField
          hintText="英文名稱"
          name="name.en"
          value={brand.name.en}
          onChange={wrapOnChange.bind(this, onChange, 'name.en')}
          type="text"
        />
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.status}>
        <RadioButtonGroup
          name="status"
          defaultSelected="active"
          valueSelected={brand.status}
          style={styles.radioButtonGroup}
          onChange={wrapOnChange.bind(this, onChange, 'status')}>
          <RadioButton
            value="active"
            label="啟用"
            style={styles.radioButton}
          />
          <RadioButton
            value="inactive"
            label="停用"
            style={styles.radioButton}
          />
        </RadioButtonGroup>
      </TableRowColumn>

      <TableRowColumn style={rowStyles.column.order}>
        <TextField
          name="order"
          value={brand.order}
          onChange={wrapOnChange.bind(this, onChange, 'order')}
          pattern="^[0-9]"
          type="text" />
      </TableRowColumn>
    </TableRow>
  );
};

BrandListRow.propTypes = {
  brand: PropTypes.object.isRequired,
  rowStyles: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default BrandListRow;



// WEBPACK FOOTER //
// client/adminPanel/panel/brands/BrandListRow.js